var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import styled from 'styled-components';
import { ThemeContext } from './common/theme';
export var Typography = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'title' : _b, text = _a.text, _c = _a.color, color = _c === void 0 ? 'primary100' : _c, style = _a.style, children = _a.children, other = __rest(_a, ["type", "text", "color", "style", "children"]);
    var theme = useContext(ThemeContext);
    return (React.createElement(StyledTypography, __assign({ type: type, color: theme[color], style: style }, other),
        text,
        children));
};
export var Title = function (props) { return (React.createElement(Typography, __assign({ as: "div" }, props, { type: "title" }), props.children)); };
export var Subtitle = function (props) { return (React.createElement(Typography, __assign({ as: "div", color: "gray100" }, props, { type: "subtitle" }), props.children)); };
export var HeaderTitle = function (props) { return (React.createElement(Typography, __assign({ as: "div" }, props, { type: "headerTitle" }), props.children)); };
export var SectionTitle = function (props) { return (React.createElement(Typography, __assign({ as: "div" }, props, { type: "sectionTitle" }), props.children)); };
export var Label = function (props) { return (React.createElement(Typography, __assign({ as: "label" }, props, { type: "label" }), props.children)); };
export var Description = function (props) { return (React.createElement(Typography, __assign({}, props, { type: "label" }), props.children)); };
var attrs = {
    title: { sizePx: 30, weight: 800 },
    subtitle: { sizePx: 13, weight: 600, lineHeightPx: 24 },
    headerTitle: { sizePx: 36, weight: 800, lineHeightPx: 48 },
    sectionTitle: { sizePx: 15, weight: 800 },
    label: { sizePx: 13, weight: 600 },
    description: { sizePx: 12, weight: 400 },
};
var StyledTypography = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  font-family: 'Open Sans', sans-serif;\n  font-size: ", "px;\n  font-weight: ", ";\n  line-height: ", ";\n  color: ", ";\n"], ["\n  display: inline-block;\n  font-family: 'Open Sans', sans-serif;\n  font-size: ", "px;\n  font-weight: ", ";\n  line-height: ",
    ";\n  color: ", ";\n"])), function (props) { return attrs[props.type].sizePx; }, function (props) { return attrs[props.type].weight; }, function (props) {
    return attrs[props.type].lineHeightPx ? attrs[props.type].lineHeightPx + 'px' : 'normal';
}, function (props) { return props.color; });
var templateObject_1;
